import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"

import "./detail.vue?vue&type=style&index=0&id=027ab30a&lang=css"
import "./detail.vue?vue&type=style&index=1&id=027ab30a&lang=scss&scoped=true"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027ab30a"]])

export default __exports__